import { openSans } from "./themes/fonts/fonts";
import { ArrayOfStringType, GenericObjectInterface, ApiResponse, CustomResponse, navItemsInterface, Theme, HeroBackgroundProps, HeroSectionProps } from './commonInterface/commonInterface';
import { makeApiRequest, BASE_URL, API_ENDPOINTS, headersList } from "./api/apiConfig";
// import {navItems} from "./constants/constants";
import { routes } from "./routes/route";
import { generateUrlSlug, parseSlug, getFirstSubcategoryWithContent } from "./helper/helper";

export type { ArrayOfStringType, GenericObjectInterface, ApiResponse, CustomResponse, navItemsInterface, Theme, HeroBackgroundProps, HeroSectionProps };
export { openSans, makeApiRequest, BASE_URL, API_ENDPOINTS, headersList };
// export {navItems};
export { routes };
export { generateUrlSlug, parseSlug, getFirstSubcategoryWithContent };